import { configureStore } from '@reduxjs/toolkit';
import businessExpansionReducer from '../slices/businessExpansionSlice';
import commonReducer from '../slices/commonSlice';
import pitchFormReducer from '../slices/pitchFormSlice';
import attractionBasicDetailReducer from '../slices/attractionBasicDetailSlice';
import attractionBusinessDetailReducer from '../slices/attractionBusinessDetailSlice';

const store = configureStore({
    reducer: {
        businessExpansion: businessExpansionReducer,
        common: commonReducer,
        pitchForm: pitchFormReducer,
        attractionBasicDetail: attractionBasicDetailReducer,
        attractionBusinessDetail: attractionBusinessDetailReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
